import { createFileRoute, redirect } from '@tanstack/react-router';

import { Settings } from '~ai-tutor/components/settings/Settings';

export const Route = createFileRoute('/_authed/settings')({
  component: Settings,
  ssr: false,
  loader: ({ context, location }) => {
    if (context.user?.identityType === 'oidc' && context.user.events.length === 0) {
      throw redirect({
        to: '/oidc/redeem-token',
        search: { redirect: location.href },
      });
    }
  },
});
